export function loadPref(key: string, fallback: string): string {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

export function savePref(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* private mode */
  }
}

export function mediaUrl(src: string): string {
  const parts = src.split('/');
  const file = parts.pop() ?? '';
  return [...parts, encodeURIComponent(file)].join('/');
}
